import {useEffect} from 'react';
import {StoryScreenModel} from '../../../entities';
import {useStoryScreensStore} from '../model/useStoryScreensStore';

/**
 * Синхронизирует экраны истории, пришедшие с сервера, с локальным стором.
 *
 * Правило одно: пока у пользователя есть несохранённые изменения, серверные данные
 * попадают только в «оригинал» (нужен для «Сбросить» и для расчёта наличия изменений),
 * а сами экраны остаются такими, какими их оставил пользователь.
 */
export const useSyncStoryScreens = (storyId: string, serverScreens: StoryScreenModel[] | undefined) => {
  const {syncScreensFromServer} = useStoryScreensStore();

  useEffect(() => {
    if (!storyId || !serverScreens) {
      return;
    }

    syncScreensFromServer(storyId, serverScreens);
  }, [storyId, serverScreens, syncScreensFromServer]);
};
